import questions from "../../assets/js/helpMultilngual/bs_es_questions";
import troubles from "../../assets/js/helpMultilngual/bs_en_troubles";
const es = {
  language: "Reino de España",
  helpCenter: {
    documentTitle: "Centro de ayuda",
    title: [
      "Vincular y Activar el Scooter",
      "Problemas de la cuenta",
      "Conducción",
      "ADAS",
      "Información y Entretenimiento",
      "Guía de uso de la aplicación",
      "Actualización del scooter",
      "Seguridad de la batería",
      "Mantenimiento",
      "Autocomprobación de Errores"
    ],
    description: "Description:",
    solution: "Suggested Solution:",
    exAssistance: "Ayuda de Cambio de Batería",
    exAssistanceList: [
      "Acerca del Servicio de Cambio de Batería Inteligente BlueShark",
      "¿Cómo obtener una Cuenta de Cambio de Batería?",
      "Acerca de los Planes de Cambio de Batería",
      "Acerca de cómo utilizar el servicio de cambio de batería"
    ],
    exAssistanceSubtitle: [
      ["Acerca del Servicio de Cambio de Batería Inteligente BlueShark"],
      [
        "¿Cómo obtener una Cuenta de Cambio de Batería?",
        "¿Cuáles son los usos de una cuenta de intercambio de baterías?"
      ],
      [
        "¿Qué es un Plan de Cambio de Batería?",
        "¿Se puede llevar y usar en el próximo mes la cuota restante de este mes?",
        "¿Es posible obtener un reembolso por el plan de cambio de batería comprado?",
        "¿Es posible renovar el plan de cambio de batería comprado?",
        "¿Cuáles son las reglas para la fecha efectiva del plan de cambio de batería?"
      ],
      [
        "Después de comprar el plan, ¿cómo realizo el primer cambio de batería?",
        "¿Cómo realizar un cambio de batería?",
        "¿Cómo puedo verificar la información de la batería en varias ubicaciones de estaciones de cambio de batería?",
        "¿Cuáles son las posibles razones para un cambio de batería fallido?"
      ]
    ],
    exAssistanceInfo: [
      [
        [
          "El servicio de intercambio de baterías inteligentes de Blueshark es un servicio rápido de recarga de energía proporcionado por Blueshark para mercados específicos. Esto incluye la instalación de estaciones de intercambio de baterías, la oferta de servicios de arrendamiento de baterías y funciones de intercambio. Aborda eficazmente la desventaja de la autonomía insuficiente en motocicletas eléctricas y puede lograr la recarga e intercambio de baterías en tan solo 3 segundos.",
          "Debido a las diferentes situaciones de demanda en distintos mercados, el servicio de intercambio de baterías inteligentes de Blueshark no cubre completamente todas las regiones de venta de vehículos Blueshark. En algunas áreas de venta, no se ofrecen servicios relevantes de intercambio y recarga de baterías. Para detalles específicos, consulte los puntos de venta locales o distribuidores."
        ]
      ],
      [
        [
          "Si el servicio de intercambio de baterías inteligente de Blueshark está disponible en tu zona, primero necesitarás descargar la aplicación de Blueshark y registrarte exitosamente en una cuenta de la app. En la página principal de la app, encontrarás la tarjeta de la función 'Servicio de Intercambio de Baterías'.",
          "Selecciona la tarjeta de la función 'Servicio de Intercambio de Baterías', elige un operador adecuado de intercambio de baterías, lee y acepta el 'Acuerdo de Servicio de Intercambio de Baterías', y podrás crear tu cuenta de intercambio.",
          "Si el servicio de intercambio de baterías inteligente de Blueshark aún no está disponible en tu zona, no podrás acceder a la tarjeta de la función 'Servicio de Intercambio de Baterías' y no podrás crear una cuenta de intercambio de baterías."
        ],
        [
          "La cuenta de intercambio de baterías es la única cuenta de identidad utilizada para acceder al servicio de intercambio de baterías inteligente de Blueshark. Sin una cuenta de intercambio de baterías, no podrás disfrutar de los beneficios del servicio de intercambio de baterías. La cuenta de intercambio de baterías se puede utilizar para comprar paquetes de intercambio, utilizar el servicio de intercambio, gestionar límites y activos de intercambio, y hacer un seguimiento de los registros de intercambio y el consumo."
        ]
      ],
      [
        [
          "Los planes de intercambio de baterías son bienes electrónicos virtuales de beneficios creados por varios operadores de intercambio de baterías que ofrecen servicios, en función de las demandas específicas de los negocios de intercambio en diferentes regiones.",
          "Actualmente, las reglas de los planes admiten tres métodos de facturación: basados en el consumo de electricidad, basados en la cantidad de intercambios de baterías y cuotas de intercambio de baterías ilimitadas. Las cuotas se asignan mensualmente, y la facturación puede realizarse mensualmente, trimestralmente o anualmente. Los planes específicos disponibles dependen de las reglas reales establecidas por el operador elegido.",
          "Al comprar un plan de intercambio de baterías, puedes disfrutar de los beneficios de los servicios de intercambio de baterías. Puedes visitar tiendas físicas o distribuidores para reclamar tus beneficios del servicio de intercambio de baterías y luego utilizar el servicio de intercambio."
        ],
        [
          "De acuerdo con las normas actuales del servicio de cambio de batería, cualquier cuota no utilizada del mes actual se reiniciará al entrar en el ciclo de facturación del próximo mes y no se acumulará para el próximo mes. Elija un plan de cambio de batería que se adapte a sus necesidades reales de consumo de electricidad para el uso diario."
        ],
        [
          "Los planes de cambio de batería son beneficios virtuales en forma de bienes electrónicos y según las normas de uso del cambio de batería, los reembolsos no son posibles. Recomendamos evaluar su compra cuidadosamente para evitar pérdidas. Gracias por su comprensión."
        ],
        [
          "Al comprar un plan de cambio de batería, preste atención a las reglas de renovación del plan. Siempre que cumpla con los criterios de renovación, es posible renovar el plan. Después de la renovación, sus beneficios de cambio de batería seguirán acumulándose en la página 'Mis Cambios'. Por favor, haga planes y renovaciones basados en sus necesidades reales."
        ],
        [
          "Después de comprar un plan de intercambio de baterías, este se hará efectivo el primer día del mes siguiente. Ten en cuenta que si necesitas que surta efecto de inmediato, debes seleccionar la opción 'Aplicar inmediatamente en el mes actual' y asegurarte de que el cupo del plan para el mes actual sea suficiente. Esto permitirá que el plan de intercambio de baterías surta efecto de inmediato. Al comprar un plan de intercambio de baterías, por favor planifica el tiempo de activación de los planes de manera razonable según tus necesidades personales."
        ]
      ],
      [
        [
          "Después de comprar el plan de intercambio de baterías, el primer paso es seguir las instrucciones de la aplicación y visitar una tienda física o la ubicación de un distribuidor para reclamar los beneficios del servicio de intercambio de baterías y registrar la batería. Si la batería es una batería arrendada, deberás visitar una tienda física o la ubicación de un distribuidor para arrendar la batería y pagar el depósito del arrendamiento de la batería.",
          "Una vez registrada, la batería será elegible para los beneficios del servicio de intercambio de baterías. Puedes insertar la batería en la estación de intercambio de baterías y la estación dispensará automáticamente una batería completamente cargada o de alta capacidad, vinculando los beneficios del servicio de intercambio de baterías a la batería recién dispensada."
        ],
        [
          "Después de que el usuario complete el registro inicial de la batería para el primer intercambio, para cada intercambio de batería posterior, simplemente inserta una batería descargada en un espacio vacío en la estación de intercambio de baterías, y la estación dispensará automáticamente una batería completamente cargada o de alta capacidad.",
          "Si la estación de intercambio de baterías no dispensa la batería como se espera, sigue las instrucciones mostradas en la pantalla de la estación y contacta al servicio al cliente para obtener ayuda."
        ],
        [
          "Puedes seleccionar el servicio de intercambio de baterías en la aplicación de Blueshark, ir a la página de inicio del mapa de intercambio de baterías y encontrar información sobre las estaciones de intercambio de baterías cercanas. Esta información incluye el nombre de la estación, la ubicación, la distancia desde tu posición y una descripción general del estado de la batería. Al hacer clic en una estación de intercambio de baterías específica, podrás acceder a su página de información detallada y ver la información de la batería para esa estación seleccionada."
        ],
        [
          "Existen varias posibles razones para un intercambio de baterías fallido:",
          "① La batería insertada tiene un servicio de intercambio de baterías vencido, lo que impide un intercambio exitoso. Debes renovar el servicio antes de usarlo.",
          "② La estación de intercambio de baterías no tiene baterías disponibles para el intercambio, lo que significa que las baterías dentro de la estación no cumplen con las condiciones de intercambio. En este caso, puedes probar en otra estación para el intercambio.",
          "③ Si ninguna de las situaciones anteriores aplica y sigues experimentando fallos repetidos en el intercambio de baterías, por favor, contacta al soporte al cliente para obtener ayuda."
        ]
      ]
    ],
    quickGuide: "Guía rápida de uso del vehículo",
    quickGuideList: [
      "Operaciones básicas",
      "Activación del vehículo",
      "Función de estacionamiento",
      "Función de conducción",
      "Montar y modo"
    ],
    QuickListSubtitle: [
      ["Operaciones básicas para H1 2023", "Operación básica de R1 2023"],
      ["Activación del vehículo H1 2023", "Activación del vehículo R1 2023"],
      [
        "H1 2023 Función de estacionamiento",
        "R1 2023 Función de estacionamiento"
      ],
      ["H1 2023 Función de conducción", "R1 2023 Función de conducción"],
      ["H1 2023 Montar y modo", "R1 2023 Montar y modo"]
    ],
    h1Node:
      "Nota: Esta guía es aplicable solo al H1 2023. Para H1 lite, consulte el manual de instrucciones. Esta guía es solo para uso de inicio rápido. Para operaciones detalladas, consulte el manual de instrucciones.",
    r1Node:
      "Nota: Esta guía es aplicable solo al R1 2023. Para R1 lite, consulte el manual de instrucciones. Esta guía es solo para uso de inicio rápido. Para operaciones detalladas, consulte el manual de instrucciones.",
    lightDescription: "Explicación de las luces indicadoras",
    signalLeft: "Señal de giro izquierda",
    signalRight: "Señal de giro derecha",
    highBeam: "Luces largas",
    lowBeam: "Luces cortas",
    lowPowerLight: "Luz de advertencia de batería baja",
    faultLight: "Luz de advertencia de fallo",
    readyLight: "Luz indicadora de preparación",
    instrumentPic: "Diagrama del tablero",
    leftKeyDescription: "Instrucciones del botón (manillar izquierdo)",
    leftHandPic: "Diagrama del manillar izquierdo",
    rightKeyDescription: "Instrucciones del botón (manillar derecho)",
    rightHandPic: "Esquema del manillar derecho",
    overtakingLightKey:
      "Interruptor de luz de adelantamiento: Alternar la luz para parpadear",
    lowBeanKey:
      "Interruptor de luz de cruce: alternar para encender la luz de cruce",
    highBeamKey:
      "Interruptor de luz larga: alternar para encender la luz larga",
    configKey:
      "Botón de confirmación: Utilizado para operaciones de confirmación en la tarjeta inteligente",
    smartKey:
      "Llave inteligente: Usada para cambiar y controlar en la tarjeta inteligente",
    LeftTrunSignalKey:
      "Palanca de intermitentes: mover a la izquierda para activar el intermitente izquierdo, presionar en el medio para apagar el intermitente",
    RightTrunSignalKey:
      "Palanca de intermitentes: mover a la derecha para activar el intermitente derecho, presionar en el medio para apagar el intermitente",
    hornKey:
      "Botón de la bocina: Presione y mantenga con la mano para hacer sonar la bocina, suelte para detener el sonido",
    cruiseControlKey:
      "Botón del control de crucero: presione brevemente para activar el control de crucero (cuando la velocidad del vehículo es superior a 15 km/h), presione brevemente nuevamente o frene para desactivar el control de crucero",
    waringKey:
      "Botón de luces de emergencia: presione para activar las luces de emergencia en caso de mal funcionamiento del vehículo o situación de emergencia.",
    costomKey: "Tecla personalizada: a actualizar",
    turboKey:
      "Tecla TURBO: presión corta para entrar en modo TURBO, presión corta de nuevo para salir",
    sportKey:
      "Tecla SPORT: presión corta para entrar en modo SPORT, presión corta de nuevo para salir",
    openSeatKey:
      "Tecla de cubo de asiento: presión corta para abrir el cubo de asiento cuando el vehículo está encendido",
    transferAssistanceKey:
      "Botón de ayuda para mover: cuando el vehículo está en estado de conducción y detenido, presione la tecla MAM para ingresar al modo de ayuda para mover. En este momento, puede operar el vehículo para moverse lentamente hacia adelante y hacia atrás girando la 'M' o el manubrio.",
    gearKey: "Botón de modo: Presione brevemente para cambiar de modo",
    LeftGearKey:
      "Tecla de cambio: desplazamiento hacia la izquierda para cambiar hacia abajo",
    RightGearKey:
      "Tecla de cambio: desplazamiento hacia la derecha para cambiar hacia arriba",
    volumeIncreaseKey:
      "Tecla de control de volumen: presione brevemente el botón derecho para aumentar el volumen",
    volumedecreaseKey:
      "Tecla de control de volumen: presione brevemente la tecla izquierda para disminuir el volumen",
    readyKey:
      "Tecla Ready: presione brevemente para cambiar entre los modos de conducción y estacionamiento",
    activationNode:
      "Nota: El vehículo se encuentra en estado inactivo al momento de la entrega y es necesario activarlo para utilizar todas las funciones y servicios.",
    activeCardPic: "Ilustración de tarjeta de activación de vehículo",
    activeUIPic: "Ilustración de la interfaz de activación del vehículo",
    activeStep1: "Paso 1: Primera página de inicio",
    activeStep2: "Paso 2: Página de guía de descarga de la aplicación",
    activeStep3: "Paso 3: Guía de página de activación",
    activeStep4: "Paso 4: Página de resultado de activación",
    activeStepInfo1: "Cuando aparezca esta tarjeta en el vehículo, presione",
    activeStepInfo2: "brevemente para ingresar al proceso de activación",
    activeStepInfo3:
      "La aplicación se puede descargar en el mercado de Android/iOS; Si ya la descargó, presione brevemente",
    activeStepInfo5: "para pasar al siguiente paso",
    activeStepInfo6:
      "Siga las instrucciones de la aplicación para buscar el vehículo, encontrar el vehículo correspondiente e ingresar el código PIN de 4 dígitos que se muestra en el tablero del vehículo para completar la activación.",
    activeStepInfo7:
      "Después de una activación exitosa, se lo redirigirá a la página de éxito (Tenga en cuenta que debe completar esta operación dentro de los 5 minutos, de lo contrario, el proceso de activación se reiniciará.)",
    instrumentDescription: "Explicación general del panel de instrumentos",
    instrumentStopPic:
      "Esquema del cuadro de instrumentos (estado estacionado)",
    instrumentWorkPic:
      "Ilustración del panel de instrumentos (estado de conducción)",
    cardPic: "Ilustración de tarjeta agregada",
    instrumentInfo1:
      "Área de tarjeta inteligente (incluidas tarjetas agregadas, estadísticas de conducción, música Bluetooth, configuración de Bluetooth, salud del vehículo, configuración del vehículo)",
    instrumentInfo2:
      "Área de información central (incluye estado de salud del vehículo, estadísticas de conducción del vehículo)",
    instrumentInfo3:
      "Área de información del vehículo (que incluye la posición del modo, la información de alcance, el estado de activación de la función)",
    aggregatedCardArea: "Área de tarjeta inteligente - Tarjetas agregadas",
    aggregatedCardInfo1:
      "Muestra el estado de reproducción de la música Bluetooth, el estado de la función de música se puede juzgar según el texto de aviso en la función de música",
    aggregatedCardInfo2:
      "Muestra el estado de conexión del Bluetooth, cuando no está conectado, el color del icono es gris, cuando se conecta con éxito, el color del icono es colorido",
    aggregatedCardInfo3:
      "Muestra el estado de encendido y apagado del registrador de conducción, cuando no está encendido, el color del icono es gris, cuando está encendido, el color del icono es colorido",
    aggregatedCardInfo4:
      "La función no está disponible todavía, por favor, espere",
    cyclingStatistics:
      "Área de tarjeta inteligente - Estadísticas de conducción",
    cyclingPic: "Ilustración de estadísticas de ciclismo",
    cyclingStatisticsInfo1:
      "Aquí se muestra el kilometraje total del vehículo desde que salió de fábrica",
    cyclingStatisticsInfo2:
      "Aquí se muestra el kilometraje de un viaje específico, puede presionar brevemente",
    cyclingStatisticsInfo3: "para restablecer estos datos",
    BluetoothMusic: "Área de tarjeta inteligente - Música Bluetooth",
    BluetoothPic: "Ilustración de música Bluetooth",
    BluetoothMusicInfo1:
      "Cuando hay audio, aquí se muestran el nombre del cantante y la letra. Cuando no hay audio, aquí se muestra 'Canción desconocida' (se requiere conexión Bluetooth y reproducción de audio a través de un dispositivo móvil)",
    BluetoothMusicInfo2: "Presione brevemente",
    BluetoothMusicInfo3: "para controlar la reproducción/pausa de música",
    BluetoothMusicInfo4: "Mantenga presionado",
    BluetoothMusicInfo5: "para cambiar a la siguiente canción",
    vehicleHealth: "Área de tarjeta inteligente - Salud del vehículo",
    healthPic: "Ilustración de salud del vehículo",
    warningPic: "Ilustración de anomalía del vehículo",
    vehicleHealthInfo1:
      "Después de encender el vehículo, cambie a esta tarjeta y automáticamente detectará el estado de salud del vehículo",
    vehicleHealthInfo2:
      "Cuando hay un problema con el estado de salud del vehículo, la tarjeta mostrará la información de fallo correspondiente y puede ver los detalles de la falla presionando brevemente el botón",
    vehicleHealthInfo3: "",
    vehicleSetting: "Área de tarjeta inteligente - Configuración del vehículo",
    settingPic: "Diagrama de ajustes del vehículo",
    vehicleSettingInfo1:
      "Esta función le permite configurar el vehículo (configuraciones incluyen: volumen de Bluetooth, sonido de motocicleta, modo de pantalla, versión del vehículo, configuración de idioma, grabadora de conducción, restablecimiento de fábrica, asistencia de seguridad, modo de vinculación pendiente, unidad de distancia, unidad de tiempo)",
    vehicleSettingInfo2:
      "Para cambiar entre diferentes funciones, puede presionar brevemente",
    vehicleSettingInfo3: "para controlar",
    vehicleSettingInfo4:
      "Cuando encuentre la función que necesita y quiera confirmar, puede presionar brevemente",
    vehicleSettingInfo5: "para confirmar",
    instrumentWorkingInfo1:
      "Área de tarjeta inteligente (incluye tarjetas agregadas, estadísticas de ciclismo, música Bluetooth)",
    instrumentWorkingInfo2:
      "Área de información central (incluye velocidad en tiempo real, información de batería)",
    instrumentWorkingInfo3:
      "Área de información del vehículo (que incluye la posición del modo, la información de alcance, la corriente en tiempo real, el consumo de energía en tiempo real)",
    aggregatedCardWorkingInfo2: "Mostrar datos de ciclismo actuales",
    startCycling: "Comenzar a conducir",
    startInfo:
      "Presione brevemente el botón 'Ready' para ingresar o salir del modo de ciclismo, el panel de instrumentos muestra la pantalla correspondiente (ver detalles a continuación)",
    gearShift: "Cambio de modo",
    gearNote:
      "Nota: El vehículo tiene un total de cinco modos, que son 【ECO】【COMFORT】【SPORT】【TURBO】【MAM】",
    H1GearNote:
      "Nota: El vehículo tiene cuatro modos en total, a saber, 【ECO】, 【COMFORT】, 【SPORT】 y 【MAM】.",
    gearInfo1:
      "El modo ECO es adecuado para la conducción eficiente en términos de energía y puede proporcionar el rango más largo",
    gearInfo2:
      "El modo COMFORT es adecuado para la conducción diaria y equilibra el alcance, la aceleración y la velocidad máxima.",
    gearInfo3:
      "El modo SPORT es adecuado para la conducción deportiva y destaca el rendimiento de adelantamiento y velocidad máxima.",
    gearInfo4:
      "El modo TURBO es adecuado para una conducción intensa y libera todo el potencial del vehículo.",
    gearInfo5: "El modo MAM es adecuado para empujar/mover el vehículo",
    gearInfo6:
      "Cambia de modo moviendo la tecla M hacia la izquierda o la derecha",
    gearInfo7: "Presione la tecla TURBO para ingresar al modo TURBO.",
    gearInfo8:
      "Mantén presionado este botón para ingresar al modo MAM, y luego gira el manillar o cambia a M- / M+ para controlar el movimiento del vehículo (M- para marcha atrás; M+ para marcha adelante)",
    gearInfo9: "Presiona la tecla M para cambiar de modo",
    gearInfo10:
      "Mantén presionado este botón para ingresar al modo MAM, luego puedes usar M-/M+ para controlar el movimiento del vehículo (M- para retroceder; M+ para avanzar).",
    drivingPage: "Página de conducción",
    parkingPage: "Página de estacionamiento",
    gearPic: "Diagrama del área de visualización de información de modo",
    questions,
    troubles
  }
};

export default es;



// WEBPACK FOOTER //
// ./src/i18n/langs/es.js